// extracted by mini-css-extract-plugin
export default {"icon":"ComparisonIcon_icon__h0dwu","tooltip":"ComparisonIcon_tooltip__nZBNx"};